module.exports = __webpack_public_path__ + "static/media/sensorButton.3a000930.png";